export default [
  'Status, Customer, Ref No.',
  'Equipment Info',
  'View & Schedule Stops',
  'Financials',
  'Truck Status Log',
  'Documents',
  'Messages'
];
